import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";

  
const BlackListPinCodesCreate = (props) => {
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [pincodes, setPinCodes] = useState("");
  const [pincodesState, setPinCodesState] = useState(false);
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { classes } = props;

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (pincodes === "") {

    setPinCodesState(true);
    return false;
    }else{
      return true;
    }

  };

  const handleCreatePinCodeSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);
      // MASTER_PINCODE_ADDBULK
      const res = await apiHandler({
        url: endpoint.MASTER_BLACK_LIST_PINCODE_ADD_BULK,
        method: "POST",
        authToken: authToken,
        data: {
          pincodes: [pincodes],
        },
      });
      setCallInProgress(false);
      //this.setState({ callInProgress: false });
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success","Created BlackList PinCode successfully", true);
        setRedirectURL(`/coreservice/BlackListPinCodes`);
      }
    }
  };
  const handleCancelPinCode = () => {
    navigate(`/coreservice/BlackListPinCodes`);
  };
  const handlePinCode = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPinCodes(e);
    }
  };
  return (
    <Grid container>
    <Grid item xs={12} sm={12} md={12}>
      <SubHeader
        label="Create Black List PinCode"
        button1=" Save"
        button2=" Cancel"
        disabled1={pincodes?.length !==6 ? true: false}
        button1click={handleCreatePinCodeSubmit}
        button2click={handleCancelPinCode}
      />
    </Grid>

    <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
             <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="PinCode"
              required
              error={pincodesState}
              id="lp_branch_code"
              value={pincodes || ''}
              setState={handlePinCode}
              type="code"
              maxLength="6"
            />
          </Grid>
          </Grid>
          </Grid>     
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
         {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
       </Grid>
  );
};

BlackListPinCodesCreate.propTypes = {
  classes: PropTypes.object,
};

export default BlackListPinCodesCreate;
